import clsx from 'clsx';

type SlotProp<P extends { className?: string }> = P | ((ownerState: unknown) => P) | undefined;

// MUI slot props (e.g. Menu/Popover/Drawer/Dialog `slotProps.paper`) accept either a plain
// object or an ownerState => object function — merge the DS class in without losing either form.
export function mergeSlotClassName<P extends { className?: string }>(slotProp: SlotProp<P>, dsClassName: string): SlotProp<P> {
  if (typeof slotProp === 'function') {
    return (ownerState: unknown) => {
      const resolved = slotProp(ownerState);
      return { ...resolved, className: clsx(dsClassName, resolved.className) };
    };
  }
  return { ...slotProp, className: clsx(dsClassName, slotProp?.className) } as P;
}
